var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6.66699C12.5 8.0477 11.3807 9.16699 10 9.16699C8.61925 9.16699 7.5 8.0477 7.5 6.66699C7.5 5.28628 8.61925 4.16699 10 4.16699C11.3807 4.16699 12.5 5.28628 12.5 6.66699Z",
    stroke: "#1F1F1F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 3.33301C14.7138 3.33301 15.833 4.4523 15.833 5.83301C15.833 6.85225 15.2231 7.72903 14.3483 8.11826",
    stroke: "#1F1F1F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4286 11.667H8.57143C6.59898 11.667 5 13.266 5 15.2384C5 16.0274 5.63959 16.667 6.42857 16.667H13.5714C14.3604 16.667 15 16.0274 15 15.2384C15 13.266 13.401 11.667 11.4286 11.667Z",
    stroke: "#1F1F1F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7617 10.833C16.7341 10.833 18.3331 12.432 18.3331 14.4044C18.3331 15.1934 17.6936 15.833 16.9046 15.833",
    stroke: "#1F1F1F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 3.33301C5.28628 3.33301 4.16699 4.4523 4.16699 5.83301C4.16699 6.85225 4.77693 7.72903 5.65173 8.11826",
    stroke: "#1F1F1F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09557 15.833C2.30658 15.833 1.66699 15.1934 1.66699 14.4044C1.66699 12.432 3.26598 10.833 5.23842 10.833",
    stroke: "#1F1F1F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamActive);
export default __webpack_public_path__ + "static/media/team-active.837d417ea4067bc76072711ad2a1b7c4.svg";
export { ForwardRef as ReactComponent };